import React from 'react';
import { observer } from 'mobx-react';
import { LevelStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import Grid from 'components/layout/grid';

@observer
class LevelEdit extends React.Component {

  componentDidMount() {
    LevelStore.getShow({ ids: {levelId: this.props.params.levelId }});
  }

  render() {
    return (
      <div className='level-edit'>
        <Grid columns={2} gap='sm'>
          <fieldset>
            <legend>Name</legend>
            {LevelStore.showDataField('name')}
          </fieldset>
          <fieldset>
            <legend>Abb</legend>
            {LevelStore.showDataField('abbreviation')}
          </fieldset>
        </Grid>
        <InPlaceText
          legend='Word List'
          inputType='textarea'
          id={LevelStore.showDataField('id')}
          defaultValue={LevelStore.showDataField('wordList')}
          model='levels'
          field='word_list'
        />
      </div>
    );
  }
}

export default LevelEdit;
